/* LTB — Mettre à jour mon point relais.

   Section `ltb-point-relais.liquid`, gabarit `page.update-point-relais-box`.
   Trois temps : l'email, le point relais choisi dans le widget Mondial Relay,
   puis l'envoi au scénario Make « Points Relais : mise à jour depuis la page
   (V2) », dont la réponse (code HTTP + `status`) choisit le message.

   L'envoi est en `application/x-www-form-urlencoded` (URLSearchParams), sans
   en-tête ajouté : c'est une requête « simple », que le navigateur envoie sans
   pré-vérification CORS. Le scénario répond avec
   `Access-Control-Allow-Origin: https://www.lathebox.fr` : depuis une autre
   origine (aperçu en .myshopify.com, éditeur de thème), la réponse est
   illisible et la page affiche l'erreur générique, même si Make a bien
   enregistré la demande. On teste donc depuis www.lathebox.fr. */
(() => {
  const racine = document.querySelector('[data-ltb-relais]');
  if (!racine || racine.dataset.relaisPret) return;
  racine.dataset.relaisPret = '1';

  const trouver = (sel) => racine.querySelector(sel);
  const champEmail = trouver('[data-relais-email]');
  const erreurEmail = trouver('[data-relais-email-erreur]');
  const piege = trouver('[data-relais-piege]');
  const zone = trouver('[data-relais-zone]');
  const widget = trouver('[data-relais-widget]');
  const chargement = trouver('[data-relais-chargement]');
  const panne = trouver('[data-relais-panne]');
  const form = trouver('[data-relais-form]');
  const vide = trouver('[data-relais-vide]');
  const choix = trouver('[data-relais-choix]');
  const nom = trouver('[data-relais-nom]');
  const adresse = trouver('[data-relais-adresse]');
  const numero = trouver('[data-relais-numero]');
  const changer = trouver('[data-relais-changer]');
  const bouton = trouver('[data-relais-bouton]');
  const boutonTexte = trouver('[data-relais-bouton-texte]');
  const manque = trouver('[data-relais-manque]');
  const statut = trouver('[data-relais-statut]');
  const alerte = trouver('[data-relais-alerte]');
  const annonce = trouver('[data-relais-annonce]');
  if (!champEmail || !widget || !form || !bouton) return;

  /* Un peu plus stricte que le filtre du scénario Make
     (`^[^'"\s@]+@[^'"\s@]+\.[^'"\s@]+$`) : ce que la page accepte, Make
     l'accepte aussi. Le but est d'arrêter une faute de frappe. */
  const ADRESSE = /^[^'"\s@]+@[^'"\s@]+\.[^'"\s@]{2,}$/;

  /* Le scénario enchaîne une dizaine d'appels (Recharge, Airtable, Klaviyo,
     Shopify) avant de répondre : il lui faut parfois plus de dix secondes. */
  const DELAI_ENVOI = 40000;
  const DELAI_LONG = 8000;
  const DELAI_WIDGET = 15000;

  /* Le widget injecte lui-même Leaflet depuis unpkg, **sans version**, dès
     qu'il ne trouve pas ces deux adresses exactes dans le <head>. Il écraserait
     alors notre Leaflet figé par la dernière version publiée — et le jour où
     elle change d'API, la carte tombe. On lui présente donc deux balises
     inertes à ces adresses : un <script type="text/plain"> n'est ni téléchargé
     ni exécuté, un <link> au `rel` inconnu non plus. */
  const LEAFLET_NON_FIGE = {
    js: 'https://unpkg.com/leaflet/dist/leaflet.js',
    css: 'https://unpkg.com/leaflet/dist/leaflet.css',
  };

  const etat = { relais: null, envoi: false, enregistre: false, emailTouche: false, panne: false };
  const libelleBouton = boutonTexte.textContent;
  const mouvementReduit = () => window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- La mesure ---------- */

  /* Même chemin que `ltb-cda.js` : pixels personnalisés, gtag, et dataLayer
     seulement si un conteneur GTM est vraiment là. Des noms à nous, et jamais
     l'email ni l'adresse du point relais. */
  const gtmCharge = () => {
    const conteneurs = window.google_tag_manager;
    if (!conteneurs) return false;
    return Object.keys(conteneurs).some((cle) => cle.indexOf('GTM-') === 0);
  };

  const mesurer = (evenement, params) => {
    const charge = Object.assign({ page: 'point_relais' }, params || {});
    try {
      const analytics = window.Shopify && window.Shopify.analytics;
      if (analytics && typeof analytics.publish === 'function') analytics.publish(evenement, charge);
    } catch (e) { /* pixel absent */ }
    try {
      if (typeof window.gtag !== 'function') {
        window.dataLayer = window.dataLayer || [];
        window.gtag = function () { window.dataLayer.push(arguments); };
      }
      window.gtag('event', evenement, charge);
    } catch (e) { /* gtag absent */ }
    try {
      if (gtmCharge() && Array.isArray(window.dataLayer)) {
        window.dataLayer.push(Object.assign({ event: evenement }, charge));
      }
    } catch (e) { /* dataLayer absent */ }
  };

  /* ---------- Les messages ---------- */

  const modele = (cle) => racine.querySelector(`template[data-relais-message="${cle}"]`);
  const texteDe = (cle) => {
    const m = modele(cle);
    return m ? m.content.textContent.replace(/\s+/g, ' ').trim() : '';
  };

  /* Le message vient de l'éditeur, avec ses liens. [relais] et [ville] sont
     remplacés dans les nœuds de texte seulement : le nom d'un point relais
     reste du texte, quoi qu'il contienne. */
  const messageDe = (cle, valeurs) => {
    const m = modele(cle);
    const fragment = m ? m.content.cloneNode(true) : document.createDocumentFragment();
    const marcheur = document.createTreeWalker(fragment, NodeFilter.SHOW_TEXT);
    const noeuds = [];
    while (marcheur.nextNode()) noeuds.push(marcheur.currentNode);
    noeuds.forEach((n) => {
      n.nodeValue = n.nodeValue.replace(/\[(relais|ville)\]/g, (tout, jeton) => (
        valeurs && valeurs[jeton] ? valeurs[jeton] : ''
      ));
    });
    return fragment;
  };

  const vider = (region) => { if (region) region.replaceChildren(); };

  const afficher = (region, cle, ton, valeurs) => {
    if (!region) return;
    const bloc = document.createElement('div');
    bloc.className = `ltb-relais__message ltb-relais__message--${ton}`;
    const icone = document.createElement('span');
    icone.className = 'ltb-relais__icone';
    icone.setAttribute('aria-hidden', 'true');
    const texte = document.createElement('p');
    texte.className = 'ltb-relais__message-texte';
    texte.append(messageDe(cle, valeurs));
    bloc.append(icone, texte);
    region.replaceChildren(bloc);
    // Sous le bouton, le message peut tomber sous la ligne de flottaison
    // d'un téléphone : on le ramène juste assez pour qu'il se voie.
    try { bloc.scrollIntoView({ block: 'nearest', behavior: mouvementReduit() ? 'auto' : 'smooth' }); } catch (e) { /* ancien navigateur */ }
  };

  const ecrireStatut = (texte) => {
    if (!statut) return;
    const p = document.createElement('p');
    p.className = 'ltb-relais__attente ltb-note';
    p.textContent = texte;
    statut.replaceChildren(p);
  };

  /* Vider puis réécrire au tour suivant : sans cela, choisir deux fois de
     suite le même point relais ne serait annoncé qu'une fois. */
  const annoncer = (texte) => {
    if (!annonce) return;
    annonce.textContent = '';
    window.setTimeout(() => { annonce.textContent = texte; }, 60);
  };

  /* ---------- La date, à l'heure de Paris ---------- */

  /* Le jour du mois vu de Paris, quel que soit le fuseau du client : un
     abonné à Montréal qui écrit le 5 à 22 h est déjà le 6 chez nous. Calculé
     à la réponse, pas au chargement : une page ouverte la veille au soir
     donnerait sinon le mauvais message. */
  const jourAParis = () => {
    try {
      const parties = new Intl.DateTimeFormat('fr-FR', { timeZone: 'Europe/Paris', day: 'numeric' }).formatToParts(new Date());
      const jour = parties.find((p) => p.type === 'day');
      if (jour) return parseInt(jour.value, 10);
    } catch (e) { /* Intl sans fuseaux : on retombe sur l'heure locale */ }
    return new Date().getDate();
  };
  const debutDeMois = () => {
    const jour = jourAParis();
    return jour >= 1 && jour <= 5;
  };

  /* ---------- L'email ---------- */

  const emailValeur = () => champEmail.value.trim();
  const emailValide = () => ADRESSE.test(emailValeur());

  const majErreurEmail = (forcer) => {
    if (!erreurEmail) return;
    const valeur = emailValeur();
    const montrer = valeur !== '' && !ADRESSE.test(valeur) && (forcer || etat.emailTouche);
    erreurEmail.hidden = !montrer;
    // L'erreur n'entre dans la description du champ que lorsqu'elle se voit :
    // un élément référencé par aria-describedby est lu même masqué.
    const aide = champEmail.getAttribute('aria-describedby').split(' ').filter((id) => id && id !== erreurEmail.id);
    if (montrer) {
      champEmail.setAttribute('aria-invalid', 'true');
      aide.push(erreurEmail.id);
    } else {
      champEmail.removeAttribute('aria-invalid');
    }
    champEmail.setAttribute('aria-describedby', aide.join(' '));
  };

  /* ---------- Le bouton ---------- */

  const MANQUE = {
    emailVideSansRelais: 'Indiquez votre email et choisissez un point relais pour continuer.',
    emailFauxSansRelais: 'Vérifiez votre email et choisissez un point relais pour continuer.',
    emailVide: 'Indiquez votre email pour continuer.',
    emailFaux: 'Vérifiez votre email pour continuer.',
    relais: 'Choisissez un point relais pour continuer.',
  };

  const majBouton = () => {
    const okEmail = emailValide();
    const okRelais = !!etat.relais;
    bouton.disabled = etat.envoi || etat.enregistre || !okEmail || !okRelais;
    racine.classList.toggle('is-envoi', etat.envoi);
    racine.classList.toggle('is-enregistre', etat.enregistre);

    let texte = '';
    if (!etat.envoi && !etat.enregistre) {
      const emailVide = emailValeur() === '';
      if (!okEmail && !okRelais) texte = emailVide ? MANQUE.emailVideSansRelais : MANQUE.emailFauxSansRelais;
      else if (!okEmail) texte = emailVide ? MANQUE.emailVide : MANQUE.emailFaux;
      else if (!okRelais) texte = MANQUE.relais;
    }
    if (manque) {
      manque.textContent = texte;
      manque.hidden = !texte;
    }
  };

  /* Après un envoi, toute modification rouvre le formulaire : le message
     affiché ne décrit plus ce qui est à l'écran. */
  const apresModification = () => {
    if (etat.envoi) return;
    if (etat.enregistre) {
      etat.enregistre = false;
      boutonTexte.textContent = libelleBouton;
    }
    vider(statut);
    vider(alerte);
  };

  /* ---------- Le point relais ---------- */

  const nettoyer = (v) => String(v == null ? '' : v).replace(/\s+/g, ' ').trim();

  const nomsDePays = (() => {
    try { return new Intl.DisplayNames(['fr'], { type: 'region' }); } catch (e) { return null; }
  })();
  const nomDuPays = (code) => {
    try { return (nomsDePays && code && nomsDePays.of(code)) || code; } catch (e) { return code; }
  };

  const rendreRecap = () => {
    const r = etat.relais;
    if (vide) vide.hidden = !!r;
    if (choix) choix.hidden = !r;
    if (!r) return;
    nom.textContent = r.nom;
    const lignes = [r.adresse1, r.adresse2, nettoyer(`${r.cp} ${r.ville}`), nomDuPays(r.pays)].filter(Boolean);
    adresse.replaceChildren();
    lignes.forEach((ligne, i) => {
      if (i) adresse.append(document.createElement('br'));
      adresse.append(ligne);
    });
    numero.textContent = `Point relais n° ${r.id}`;
  };

  /* Le widget rappelle cette fonction avec des champs vides quand il retire
     la sélection : le récapitulatif redevient vide et le bouton se referme. */
  const choisir = (d) => {
    const id = nettoyer(d && d.ID);
    etat.relais = id ? {
      id,
      nom: nettoyer(d.Nom),
      adresse1: nettoyer(d.Adresse1),
      adresse2: nettoyer(d.Adresse2),
      cp: nettoyer(d.CP),
      ville: nettoyer(d.Ville),
      pays: nettoyer(d.Pays).toUpperCase(),
    } : null;
    apresModification();
    rendreRecap();
    majBouton();
    if (etat.relais) annoncer(`Point relais choisi : ${etat.relais.nom}, ${etat.relais.ville}.`);
  };

  /* ---------- Le widget Mondial Relay ---------- */

  const enPanne = () => {
    if (etat.panne || widget.childElementCount) return;
    etat.panne = true;
    if (chargement) chargement.hidden = true;
    if (panne) panne.hidden = false;
    mesurer('relais_widget_panne');
  };

  const figerLeaflet = () => {
    if (typeof window.L === 'undefined') return; // notre Leaflet n'a pas chargé : on laisse le widget se servir
    const tete = document.head;
    if (![...tete.getElementsByTagName('script')].some((el) => el.src === LEAFLET_NON_FIGE.js)) {
      const script = document.createElement('script');
      script.type = 'text/plain';
      script.src = LEAFLET_NON_FIGE.js;
      script.dataset.ltbRelais = 'leaflet-fige';
      tete.append(script);
    }
    if (![...tete.getElementsByTagName('link')].some((el) => el.href === LEAFLET_NON_FIGE.css)) {
      const lien = document.createElement('link');
      lien.rel = 'x-ltb-leaflet-fige';
      lien.href = LEAFLET_NON_FIGE.css;
      tete.append(lien);
    }
  };

  /* La liste du widget est faite de <div onclick> : ni atteignables au
     clavier, ni annoncées comme des boutons. On les complète à chaque
     recherche — le widget redessine sa liste — sans toucher à leur clic. Et
     ses libellés « Ville » et « CP » ne sont reliés à aucun champ : on les
     relie, pour qu'un lecteur d'écran dise ce qu'il faut taper. */
  let retouchePrevue = false;
  const retoucherWidget = () => {
    retouchePrevue = false;
    widget.querySelectorAll('.PR-List-Item:not([data-ltb-clavier])').forEach((item) => {
      item.dataset.ltbClavier = '1';
      item.setAttribute('tabindex', '0');
      item.setAttribute('role', 'button');
    });
    widget.querySelectorAll('.MRW-Container').forEach((bloc) => {
      const libelle = bloc.querySelector('label');
      const champ = bloc.querySelector('input[type="text"]');
      if (libelle && champ && champ.id && !libelle.htmlFor) libelle.htmlFor = champ.id;
    });
  };
  new MutationObserver(() => {
    if (retouchePrevue) return;
    retouchePrevue = true;
    window.requestAnimationFrame(retoucherWidget);
  }).observe(widget, { childList: true, subtree: true });

  widget.addEventListener('keydown', (ev) => {
    const item = ev.target.closest && ev.target.closest('.PR-List-Item');
    if (!item || !widget.contains(item)) return;
    if (ev.key === 'Enter' || ev.key === ' ') {
      ev.preventDefault();
      item.click();
    }
  });

  const demarrerWidget = () => {
    const jq = window.jQuery;
    if (!jq || !jq.fn || typeof jq.fn.MR_ParcelShopPicker !== 'function') {
      enPanne();
      return;
    }

    // Le widget dessine dans le bloc : dès qu'il y a quelque chose, le texte
    // d'attente s'efface — et la panne aussi, si le réseau était seulement lent.
    const observateur = new MutationObserver(() => {
      if (!widget.childElementCount) return;
      if (chargement) chargement.hidden = true;
      if (panne) panne.hidden = true;
      etat.panne = false;
      observateur.disconnect();
    });
    observateur.observe(widget, { childList: true });
    window.setTimeout(enPanne, DELAI_WIDGET);

    figerLeaflet();

    const options = {
      Target: '#LtbRelaisCible',
      Brand: racine.dataset.enseigne || 'CC22YB6I',
      Country: (racine.dataset.pays || 'FR').toUpperCase(),
      AllowedCountries: racine.dataset.paysAutorises || 'FR,BE,LU,NL,ES,PT,DE,AT,IT',
      Responsive: true,
      ShowResultsOnMap: true,
      NbResults: '10',
      OnParcelShopSelected: choisir,
    };
    // Client connecté : la recherche part de son code postal. Seulement les
    // codes tout en chiffres — un « 1012 AB » néerlandais ferait échouer la
    // première recherche au lieu d'aider.
    const cp = (racine.dataset.codePostal || '').replace(/\s+/g, '');
    if (/^[0-9]{4,5}$/.test(cp)) options.PostCode = cp;

    try {
      jq(widget).MR_ParcelShopPicker(options);
    } catch (e) {
      enPanne();
    }
  };

  /* ---------- L'envoi ---------- */

  const envoyer = async () => {
    const r = etat.relais;
    const url = racine.dataset.webhook;
    const corps = new URLSearchParams();
    corps.set('email', emailValeur());
    corps.set('relay_id', r.id);
    corps.set('relay_name', r.nom);
    corps.set('relay_address', [r.adresse1, r.adresse2].filter(Boolean).join(' '));
    corps.set('relay_zip', r.cp);
    corps.set('relay_city', r.ville);
    corps.set('relay_country', r.pays);
    // Le piège ne part que s'il est rempli. Le scénario refuse toute demande
    // où `website` « existe » : l'envoyer vide ferait dépendre chaque demande
    // légitime de la façon dont Make juge une chaîne vide.
    const valeurPiege = piege ? piege.value : '';
    if (valeurPiege) corps.set('website', valeurPiege);

    if (!url) return 'erreur';

    const controleur = typeof AbortController === 'function' ? new AbortController() : null;
    const minuterie = window.setTimeout(() => { if (controleur) controleur.abort(); }, DELAI_ENVOI);
    try {
      const reponse = await fetch(url, {
        method: 'POST',
        body: corps,
        credentials: 'omit',
        cache: 'no-store',
        signal: controleur ? controleur.signal : undefined,
      });
      let donnees = null;
      try { donnees = await reponse.json(); } catch (e) { /* « Accepted » ou page d'erreur : pas du JSON */ }
      const code = donnees && typeof donnees === 'object' ? donnees.status : null;
      if (reponse.status === 200 && code === 'ok') return 'ok';
      if (reponse.status === 404 && code === 'not_found') return 'not_found';
      if (reponse.status === 409 && code === 'multiple') return 'multiple';
      if (reponse.status === 400 && code === 'invalid') return 'invalid';
      return 'erreur';
    } catch (e) {
      return 'erreur'; // réseau, CORS, délai dépassé
    } finally {
      window.clearTimeout(minuterie);
    }
  };

  form.addEventListener('submit', async (ev) => {
    ev.preventDefault();
    if (etat.envoi || etat.enregistre) return;

    etat.emailTouche = true;
    majErreurEmail(true);
    if (!emailValide() || !etat.relais) {
      majBouton();
      if (!emailValide() && !champEmail.readOnly) champEmail.focus();
      else zone.focus();
      return;
    }

    const relais = etat.relais;
    etat.envoi = true;
    bouton.setAttribute('aria-busy', 'true');
    boutonTexte.textContent = texteDe('bouton_envoi') || libelleBouton;
    vider(alerte);
    ecrireStatut(texteDe('envoi'));
    majBouton();
    const long = window.setTimeout(() => ecrireStatut(texteDe('envoi_long')), DELAI_LONG);

    const resultat = await envoyer();
    window.clearTimeout(long);

    etat.envoi = false;
    bouton.removeAttribute('aria-busy');
    vider(statut);
    const debut = debutDeMois();
    if (resultat === 'ok') {
      etat.enregistre = true;
      boutonTexte.textContent = texteDe('bouton_ok') || libelleBouton;
      afficher(statut, debut ? 'ok_debut' : 'ok', 'ok', { relais: relais.nom, ville: relais.ville });
    } else {
      boutonTexte.textContent = libelleBouton;
      afficher(alerte, resultat, resultat === 'multiple' ? 'info' : 'erreur');
    }
    majBouton();
    mesurer('relais_envoi', { resultat, pays: relais.pays, periode: debut ? 'debut_de_mois' : 'mois' });
  });

  /* ---------- Branchements ---------- */

  champEmail.addEventListener('input', () => {
    apresModification();
    if (etat.emailTouche) majErreurEmail();
    majBouton();
  });
  champEmail.addEventListener('blur', () => {
    if (emailValeur() !== '') etat.emailTouche = true;
    majErreurEmail();
  });

  if (changer) {
    changer.addEventListener('click', () => {
      try { zone.scrollIntoView({ block: 'start', behavior: mouvementReduit() ? 'auto' : 'smooth' }); } catch (e) { zone.scrollIntoView(); }
      const recherche = zone.querySelector('input[type="text"], input:not([type]), input[type="search"]');
      (recherche || zone).focus({ preventScroll: true });
    });
  }

  rendreRecap();
  majBouton();
  demarrerWidget();
})();
